export default {
  "components": {
    "dates": {
      "sun": {
        "default": "Sunday",
        "value": "Sonntag"
      },
      "mon": {
        "default": "Monday",
        "value": "Montag"
      },
      "tue": {
        "default": "Tuesday",
        "value": "Dienstag"
      },
      "wed": {
        "default": "Wednesday",
        "value": "Mittwoch"
      },
      "thu": {
        "default": "Thursday",
        "value": "Donnerstag"
      },
      "fri": {
        "default": "Friday",
        "value": "Freitag"
      },
      "sat": {
        "default": "Saturday",
        "value": "Samstag"
      },
      "suns": {
        "default": "Sun",
        "value": "So"
      },
      "mons": {
        "default": "Mon",
        "value": "Mo"
      },
      "tues": {
        "default": "Tue",
        "value": "Di"
      },
      "weds": {
        "default": "Wed",
        "value": "Mi"
      },
      "thus": {
        "default": "Thu",
        "value": "Do"
      },
      "fris": {
        "default": "Fri",
        "value": "Fr"
      },
      "sats": {
        "default": "Sat",
        "value": "Sa"
      },
      "jan": {
        "default": "January",
        "value": "Januar"
      },
      "feb": {
        "default": "February",
        "value": "Februar"
      },
      "mar": {
        "default": "March",
        "value": "März"
      },
      "apr": {
        "default": "April",
        "value": "April"
      },
      "may": {
        "default": "May",
        "value": "Mai"
      },
      "jun": {
        "default": "June",
        "value": "Juni"
      },
      "jul": {
        "default": "July",
        "value": "Juli"
      },
      "aug": {
        "default": "August",
        "value": "August"
      },
      "sep": {
        "default": "September",
        "value": "September"
      },
      "oct": {
        "default": "October",
        "value": "Oktober"
      },
      "nov": {
        "default": "November",
        "value": "November"
      },
      "dec": {
        "default": "December",
        "value": "Dezember"
      },
      "jans": {
        "default": "Jan",
        "value": "Jan"
      },
      "febs": {
        "default": "Feb",
        "value": "Feb"
      },
      "mars": {
        "default": "Mar",
        "value": "Mrz"
      },
      "aprs": {
        "default": "Apr",
        "value": "Apr"
      },
      "mays": {
        "default": "May",
        "value": "Mai"
      },
      "juns": {
        "default": "Jun",
        "value": "Jun"
      },
      "juls": {
        "default": "Jul",
        "value": "Jul"
      },
      "augs": {
        "default": "Aug",
        "value": "Aug"
      },
      "seps": {
        "default": "Sep",
        "value": "Sep"
      },
      "octs": {
        "default": "Oct",
        "value": "Okt"
      },
      "novs": {
        "default": "Nov",
        "value": "Nov"
      },
      "decs": {
        "default": "Dec",
        "value": "Dez"
      }
    },
    "commonPersonalData": {
      "errInvalidFields": {
        "default": "Invalid form fields.",
        "value": "Ungültige Eingabefelder"
      },
      "personalDataSaved": {
        "default": "Your data has been saved.",
        "value": "Ihre Daten wurden gespeichert."
      }
    },
    "validations": {
      "cannotBeEmpty": {
        "default": "This field cannot be empty.",
        "value": "Dies ist ein Pflichtfeld."
      },
      "notAnEmail": {
        "default": "Provided value is not a valid email address.",
        "value": "Das ist keine gültige E-Mail Adresse."
      },
      "passwordLength": {
        "default": "The password must be minimum ${charNo} characters with at least one lowercase character and one special character.",
        "value": "Das Passwort muss mindestens ${charNo} Zeichen lang sein, davon mindestens ein Kleinbuchstabe und ein Sonderzeichen."
      }
    },
    "bwReceipt": {
      "barOffer": {
        "default": "Offer",
        "value": "Angebot"
      },
      "barExtras": {
        "default": "Extras",
        "value": "Extras"
      },
      "barMietbetrag": {
        "default": "Rental fee",
        "value": "Preis"
      },
      "recOffer": {
        "default": "Offer",
        "value": "Angebot"
      },
      "recServices": {
        "default": "Services",
        "value": "Dienstleistungen"
      },
      "recDiscount": {
        "default": "Discount",
        "value": "Rabatt"
      },
      "recAccessories": {
        "default": "Accessories",
        "value": "Extras"
      },
      "recDeposit": {
        "default": "Kaution",
        "value": "Kaution"
      },
      "bookedFrom": {
        "default": "Booking from",
        "value": "Buchung von"
      },
      "bookedTo": {
        "default": "to",
        "value": "bis"
      },
      "totalDiscount": {
        "default": "Total Discount",
        "value": "Rabatt"
      },    
      "totalSurcharge": {
        "default": "Total Discount",
        "value": "Gesamtzuschlag"
      },          
      "vatIncluded": {
        "default": "All prices are including VAT.",
        "value": "Alle Preise inklusive Mwst."
      }            
    },
    "bwStepBar": {
      "bookingDates": {
        "default": "Bookingdates",
        "value": "Buchungsdaten"
      },
      "services": {
        "default": "Services",
        "value": "Dienstleistungen"
      },
      "accessories": {
        "default": "Accessories",
        "value": "Extras"
      },
      "personalData": {
        "default": "Contact data",
        "value": "Personalien"
      },
      "review": {
        "default": "Review",
        "value": "Überprüfen"
      },
      "payment": {
        "default": "Payment",
        "value": "Zahlung"
      }
    },
    "siteHeader": {
      "passwordRecovery": {
        "default": "Passwort vergessen?",
        "value": "Passwort vergessen?"
      },      
      "login": {
        "default": "Login",
        "value": "Anmelden"
      },
      "userName": {
        "default": "Username",
        "value": "Benutzername"
      },
      "password": {
        "default": "Password",
        "value": "Passwort"
      },
      "performLogin": {
        "default": "Login",
        "value": "Anmelden"
      },
      "newRegistration": {
        "default": "Sign up",
        "value": "Neu registrieren"
      },
      "userProfile": {
        "default": "My profile",
        "value": "Mein Profil"
      },
      "userBookings": {
        "default": "My bookings",
        "value": "Meine Buchungen"
      },
      "performLogout": {
        "default": "Log out",
        "value": "Abmelden"
      }
    },
    "siteFooter": {
      "claimText1": {
        "default": "Das umfassende",
        "value": "Das umfassende"        
      },
      "claimText2": {
        "default": "Reservationssystem",
        "value": "Reservationssystem"   
      },  
      "claimText3": {
        "default": "für Sie",
        "value": "für Sie"
      }          
    }    
  },
  "pages": {
    "bw03Accessories": {
      "back": {
        "default": "Back",
        "value": "Zurück"
      },
      "accessories": {
        "default": "Accessories",
        "value": "Extras"
      },
      "next": {
        "default": "Next",
        "value": "Weiter"
      }
    },
    "bw07BookingFinished": {
      "confirmation": {
        "default": "Confirmation",
        "value": "Bestätigung"
      },
      "bookingFor": {
        "default": "The booking for",
        "value": "Die Buchung für"
      },
      "fromDate": {
        "default": "from",
        "value": "von"
      },
      "toDate": {
        "default": "to",
        "value": "bis"
      },
      "forPrice": {
        "default": "for",
        "value": "für"
      },
      "wasFinished": {
        "default": "was successfully completed.",
        "value": "wurde erfolgreich abgeschlossen."
      },
      "bookingDetailsSent": {
        "default": "The booking details and invoice have been sent to your e-mail address.",
        "value": "Die Buchungsdetails wurden an Ihre E-Mail Adresse gesandt."
      },
      "performRegister": {
        "default": "Sign up",
        "value": "Neu registrieren"
      },
      "performPrint": {
        "default": "Print confirmation",
        "value": "Bestätigung drucken"
      },
      "goHome": {
        "default": "Go to homepage ",
        "value": "Zur Startseite"
      }
    },
    "bw01OfferDetails": {
      "next": {
        "default": "Next",
        "value": "Weiter"
      },
      "bookingDates": {
        "default": "Booking data",
        "value": "Buchungsdaten"
      },
      "instructionsTitle1": {
        "default": "Instructions",
        "value": "Anleitung"
      },
      "instructionsText1": {
        "default": "Passen Sie bei Bedarf die Start- und Endzeiten an. Beachten Sie, dass das System Ihre Angaben automatisch korrigieren kann um die Buchungsregeln des Anbieters zu berücksichtigen.",
        "value": "Passen Sie bei Bedarf die Start- und Endzeiten an. Beachten Sie, dass das System Ihre Angaben automatisch korrigieren kann um die Buchungsregeln des Anbieters zu berücksichtigen."
      },      
      "startDate": {
        "default": "Start time",
        "value": "Startzeit"
      },
      "endDate": {
        "default": "End time",
        "value": "Endzeit"
      },
      "applyNewValues": {
        "default": "Show",
        "value": "Anzeigen"
      },
      "weekView": {
        "default": "Week view",
        "value": "Wochenansicht"
      },
      "monthView": {
        "default": "Month view",
        "value": "Zur Monatsansicht"
      },
      "yourChoice": {
        "default": "Your selection",
        "value": "Ihre Auswahl"
      },
      "instructionsTitle2": {
        "default": "Instructions",
        "value": "Anleitung"
      },
      "yourBooking": {
        "default": "Your reservation",
        "value": "Ihre Buchung"
      },
      "notAvailable": {
        "default": "Not available",
        "value": "Nicht verfügbar"
      },
      "pickupDrop": {
        "default": "Pickup and return times",
        "value": "Start- & Endzeiten"
      },
      "back": {
        "default": "Back",
        "value": "Zurück"
      }
    },
    "bw06Payment": {
      "payment": {
        "default": "Payment",
        "value": "Zahlung"
      },
      "bankAccount": {
        "default": "Banking details",
        "value": "Bankverbindung"
      },
      "bankPaymentConditions": {
        "default": "Payment conditions",
        "value": "Zahlungsbedingungen"
      },
      "back": {
        "default": "Back",
        "value": "Zurück"
      },
      "firmlyBookFor": {
        "default": "Book bindingly for",
        "value": "Verbindlich buchen für"
      }
    },
    "bw04PersonalData": {
      "street": {
        "default": "Street, Nr. *",
        "value": "Strasse, Nr. *"
      },
      "addressAddition": {
        "default": "Address suffix",
        "value": "Adresszusatz"
      },
      "postNumber": {
        "default": "ZIP *",
        "value": "PLZ *"
      },
      "place": {
        "default": "Place *",
        "value": "Ort *"
      },
      "country": {
        "default": "Country *",
        "value": "Land *"
      },
      "back": {
        "default": "Back",
        "value": "Zurück"
      },
      "personalData": {
        "default": "Contact details",
        "value": "Personalien"
      },
      "pleaseLogin": {
        "default": "Please log in",
        "value": "Bitte anmelden"
      },
      "userName": {
        "default": "User name",
        "value": "Benutzername"
      },
      "password": {
        "default": "Password",
        "value": "Passwort"
      },
      "loginAsGuest": {
        "default": "Book as guest",
        "value": "Als Gast buchen"
      },
      "login": {
        "default": "Log in",
        "value": "Anmelden"
      },
      "customerInformation": {
        "default": "Customer information",
        "value": "Kundeninformation"
      },
      "salutation": {
        "default": "Salutation *",
        "value": "Anrede *"
      },
      "firstName": {
        "default": "First name *",
        "value": "Vorname *"
      },
      "lastName": {
        "default": "Family Name *",
        "value": "Nachname *"
      },
      "organization": {
        "default": "Organization",
        "value": "Organisation"
      },       
      "email": {
        "default": "Email *",
        "value": "E-Mail *"
      },
      "phone": {
        "default": "Phone",
        "value": "Telefon"
      },
      "mobilePhone": {
        "default": "Cellphone *",
        "value": "Mobiltelefon *"
      },       
      "address": {
        "default": "Address",
        "value": "Adresse"
      },
      "useDifferentBillingAddress": {
        "default": "Use different address for billing.",
        "value": "Abweichende Rechnungsadresse"
      },
      "cancelGuestLogin": {
        "default": "Cancel guest booking",
        "value": "Gastbuchung abbrechen"
      },
      "next": {
        "default": "Next",
        "value": "Weiter"
      }
    },
    "bw05Review": {
      "discount": {
        "default": "Disount",
        "value": "Rabatt"
      },
      "totalDiscount": {
        "default": "Total Discount",
        "value": "Rabatt"
      }, 
      "totalSurcharge": {
        "default": "Total Discount",
        "value": "Gesamtzuschlag"
      },                
      "offer": {
        "default": "Angebot",
        "value": "Angebot"
      },  
      "services": {
        "default": "Dienstleistungen",
        "value": "Dienstleistungen"
      },     
      "accessories": {
        "default": "Extras",
        "value": "Extras"
      },           
      "deposit": {
        "default": "Kaution",
        "value": "Kaution"
      },      
      "review": {
        "default": "Review",
        "value": "Überprüfen"
      },
      "mietbetrag": {
        "default": "Rental fee",
        "value": "Preis"
      },
      "bookedFrom": {
        "default": "Booking from",
        "value": "Buchung von"
      },
      "bookedTo": {
        "default": "to",
        "value": "bis"
      },
      "bookingDetails": {
        "default": "Bookingdetails",
        "value": "Buchungsdetails"
      },
      "vatIncluded": {
        "default": "Incl. VAT.",
        "value": "inkl. Mwst."
      },
      "voucher": {
        "default": "Voucher",
        "value": "Gutschein"
      }, 
      "addVoucher": {
        "default": "Add Voucher",
        "value": "Gutschein hinzufügen"
      },       
      "bookAs": {
        "default": "Book as",
        "value": "Buchen als"
      },
      "bookFirmly": {
        "default": "Book bindingly",
        "value": "Verbindlich buchen"
      },
      "temporaryReservationUntil": {
        "default": "Temporäre Reservation, gültig bis",
        "value": "Temporäre Reservation, gültig bis"
      },
      "acceptAGB": {
        "default": "I accept the",
        "value": "Ich akzeptiere die ${lessorName}"
      },
      "agb": {
        "default": "General terms and conditions",
        "value": "AGB"
      },
      "back": {
        "default": "Back",
        "value": "Zurück"
      },
      "next": {
        "default": "Next",
        "value": "Weiter"
      },
      "nextTitle": {
        "default": "Alle Pflichtfelder müssen ausgefüllt und die AGBs akzeptieren werden.",
        "value": "Alle Pflichtfelder müssen ausgefüllt und die AGBs akzeptieren werden."
      }      
    },
    "bw02Services": {
      "next": {
        "default": "Next",
        "value": "Weiter"
      },
      "services": {
        "default": "Services",
        "value": "Dienstleistungen"
      },
      "back": {
        "default": "Back",
        "value": "Zurück"
      }
    },
    "objectDetail": {
      "back": {
        "default": "Back",
        "value": "Zurück"
      },
      "fromPrice": {
        "default": "Starting at",
        "value": "Ab"
      },
      "bookObject": {
        "default": "Book objects",
        "value": "Buchen"
      },
      "properties": {
        "default": "Features",
        "value": "Eigenschaften"
      },
      "notBookableOnline": {
        "default": "Kann nicht online gebucht werden. Bitte kontaktieren Sie den Anbieter.",
        "value": "Kann nicht online gebucht werden. Bitte kontaktieren Sie den Anbieter."
      },      
      "showMoreProperties": {
        "default": "Show more features",
        "value": "Weitere Eigenschaften anzeigen"
      },
      "showLessProperties": {
        "default": "Close",
        "value": "Schliessen"
      },
      "attachments": {
        "default": "Attachments",
        "value": "Anhänge"
      },
      "unnamedAttachment": {
        "default": "Attachment",
        "value": "Anhang"
      },
      "showMoreAttachments": {
        "default": "Show more attachements",
        "value": "Weitere Anhänge anzeigen"
      },
      "showLessAttachments": {
        "default": "Close",
        "value": "Schliessen"
      },
      "availableDates": {
        "default": "Available dates",
        "value": "Verfügbare Daten"
      },
      "availableDatesDescription": {
        "default": "If necessary, change booking dates in the next step.",
        "value": "Die gewünschten Buchungsdaten können im nächsten Schritt angepasst werden."
      },
      "weekView": {
        "default": "Week view",
        "value": "Wochenansicht"
      },
      "monthView": {
        "default": "Month view",
        "value": "Zur Monatsansicht"
      },
      "yourChoice": {
        "default": "Your selection",
        "value": "Ihre Auswahl"
      },
      "notAvailable": {
        "default": "Not available",
        "value": "Nicht verfügbar"
      },
      "pickupDrop": {
        "default": "Pickup and return times",
        "value": "Start- & Endzeiten"
      },
      "offers": {
        "default": "Offers",
        "value": "Angebote"
      },
      "consumables": {
        "default": "Consumables",
        "value": "Nutzung"
      },
      "services": {
        "default": "Services",
        "value": "Dienstleistungen"
      },
      "accessories": {
        "default": "Accessories",
        "value": "Extras"
      },
      "cancellationFees": {
        "default": "Cancellation fees",
        "value": "Storno-Gebühren"
      },
      "seasonDatetimes": {
        "default": "Saisonzeiten",
        "value": "Saisonzeiten"
      },
      "pickups": {
        "default": "Startzeit",
        "value": "Startzeit"
      },
      "dropoffs": {
        "default": "Endzeit",
        "value": "Endzeit"
      },
      "prolongation": {
        "default": "Verlängerung",
        "value": "Verlängerung"
      },        
      "description": {
        "default": "Description",
        "value": "Beschreibung"
      }, 
      "noOfferItems": {
        "default": "There are no offers.",
        "value": "Keine Angebote"
      },
      "showMoreOffers": {
        "default": "Show more offers",
        "value": "Mehr Angebote anzeigen"
      },
      "showLessOffers": {
        "default": "Close",
        "value": "Schliessen"
      },
      "noConsumables": {
        "default": "There are no consumables.",
        "value": "Keine Nutzdaten"
      },
      "consumablesTabDescription": {
        "default": "Included consumables",
        "value": "Inbegriffene Nutzung"
      },
      "showMoreConsumables": {
        "default": "Show more consumables",
        "value": "Mehr Nutzungskosten anzeigen"
      },
      "showLessConsumables": {
        "default": "Close",
        "value": "Schliessen"
      },
      "consumableMinimum": {
        "default": "At least",
        "value": "mindestens"
      },       
      "consumableFooterDescription": {
        "default": "pro zusätzliche(n)",
        "value": "pro zusätzliche(n)"
      }, 
      "noServices": {
        "default": "There are no services.",
        "value": "Keine Dienstleistungen"
      },
      "discount": {
        "default": "Discount",
        "value": "Rabatt"
      },
      "showMoreServices": {
        "default": "Show more services",
        "value": "Mehr Dienstleistungen anzeigen"
      },
      "showLessServices": {
        "default": "Close",
        "value": "Schliessen"
      },
      "noAccessories": {
        "default": "There are no accessories.",
        "value": "Keine Extras"
      },
      "showMoreAccessories": {
        "default": "Show more accessories",
        "value": "Mehr Extras anzeigen"
      },
      "showLessAccessories": {
        "default": "Close",
        "value": "Schliessen"
      },
      "noCancellationFees": {
        "default": "No cancellation fees",
        "value": "Keine Stornogebühren"
      },
      "daysToPickup": {
        "default": "Days until pickup",
        "value": "Tage bis zum Start, oder früher"
      },
      "hoursToPickup": {
        "default": "Hours until pickup",
        "value": "Stunden bis zum Start, oder früher"
      },      
      "percent": {
        "default": "Percent",
        "value": "Prozent"
      },
      "fix": {
        "default": "Fix",
        "value": "Fix"
      },
      "showMoreCancellationFees": {
        "default": "Show more fees",
        "value": "Mehr Gebühren anzeigen"
      },
      "showLessCancellationFees": {
        "default": "Close",
        "value": "Schliessen"
      }
    },
    "home": {
      "location": {
        "default": "Location",
        "value": "Standort"
      },
      "allLocationsSelected": {
        "default": "All locations",
        "value": "Alle"
      },
      "selectAllLocations": {
        "default": "All locations",
        "value": "Alle"
      },
      "noItemsLoadedYet": {
        "default": "No items loaded yet.",
        "value": "Noch keine Einträge geladen"
      },
      "objectType": {
        "default": "Category",
        "value": "Kategorie"
      },
      "allCategoriesSelected": {
        "default": "All categories",
        "value": "Alle"
      },
      "selectAllCategories": {
        "default": "All categories.",
        "value": "Alle"
      },
      "startDate": {
        "default": "Start date *",
        "value": "Start Datum *"
      },
      "noStartDateSelected": {
        "default": "No start date selected.",
        "value": "Kein Startdatum gewählt."
      },
      "duration": {
        "default": "Duration *",
        "value": "Dauer *"
      },
      "to": {
        "default": "to",
        "value": "bis"
      },
      "count": {
        "default": "Number",
        "value": "Anzahl"
      },
      "enterUnitsCount": {
        "default": "Enter units count",
        "value": "Anzahl eingeben"
      },
      "timeUnit": {
        "default": "Time unit",
        "value": "Zeiteinheit"
      },
      "enterUnitsType": {
        "default": "Enter units type",
        "value": "Zeiteinheit wählen"
      },
      "search": {
        "default": "Search",
        "value": "Suchen"
      },
      "priceFrom": {
        "default": "From",
        "value": "Ab"
      }
    },
    "userBookingDetail": {
      "cancelBookingMessage": {
        "default": "You are going to cancel this booking. Are you sure?",
        "value": "Wollen Sie die Buchung wirklich stornieren?" 
      },      
      "enthalteneMwst": {
        "default": "Enthaltene MwSt (${vatPercentage}%)",
        "value": "Enthaltene MwSt (${vatPercentage}%)"
      },
      "stornoGebuhren": {
        "default": "Storno-Gebühren",
        "value": "Storno-Gebühren"
      },
      "daysToPickup": {
        "default": "Tage bis zur Startzeit, oder früher",
        "value": "Tage bis zur Startzeit, oder früher"
      },
      "hoursToPickup": {
        "default": "Stunden bis zur Startzeit, oder früher",
        "value": "Stunden bis zur Startzeit, oder früher"
      },      
      "gesamtbetragFallig": {
        "default": "Gesamtbetrag, fällig",
        "value": "Gesamtbetrag, fällig"
      },
      "anzahlungFallig": {
        "default": "Anzahlung, fällig",
        "value": "Anzahlung, fällig"
      },
      "back": {
        "default": "Returned",
        "value": "Zurück"
      },
      "performPrint": {
        "default": "Print",
        "value": "Drucken"
      },
      "performCancel": {
        "default": "Cancel",
        "value": "Stornieren"
      },
      "mietbetrag": {
        "default": "Rental fee",
        "value": "Preis"
      },
      "vatIncluded": {
        "default": "Incl. VAT.",
        "value": "inkl. Mwst."
      },      
      "bookedFrom": {
        "default": "Booking from",
        "value": "Buchung von"
      },
      "bookedTo": {
        "default": "to",
        "value": "bis"
      },
      "bookingNumber": {
        "default": "Booking-No.",
        "value": "Buchungs-Nr."
      },
      "bookingState": {
        "default": "Status",
        "value": "Status"
      },
      "bookingSaldo": {
        "default": "Balance",
        "value": "Zahlungssaldo"
      },
      "objectAndAccessories": {
        "default": "Rental object and accessories",
        "value": "Objekt und Extras"
      },
      "description": {
        "default": "Description",
        "value": "Beschreibung"
      },
      "count": {
        "default": "Qty.",
        "value": "Anzahl"
      },
      "offer": {
        "default": "Offer",
        "value": "Angebot"
      },
      "season": {
        "default": "Season",
        "value": "Saison"
      },
      "deposit": {
        "default": "Kaution",
        "value": "Kaution"
      },        
      "price": {
        "default": "Price",
        "value": "Preis"
      },
      "subTotal": {
        "default": "Subtotal",
        "value": "Zwischensumme"
      },
      "conditionalServices": {
        "default": "Conditional fees",
        "value": "Bedingte Gebühren"
      },
      "article": {
        "default": "Article",
        "value": "Artikel"
      },
      "subtotal": {
        "default": "Subtotal",
        "value": "Zwischensumme"
      },
      "services": {
        "default": "Services",
        "value": "Dienstleistungen"
      },
      "discount": {
        "default": "Discount",
        "value": "Rabatt"
      },
      "totalDiscount": {
        "default": "Total Discount",
        "value": "Rabatt"
      },          
      "consumables": {
        "default": "Consumables",
        "value": "Nutzung"
      },
      "consumableName": {
        "default": "Description",
        "value": "Bezeichnung"
      },
      "unit": {
        "default": "Unit",
        "value": "Einheit"
      },
      "minIncl": {
        "default": "Min. / Incl.",
        "value": "Min. / Inkl."
      },
      "pricePerUnit": {
        "default": "Price / Unit",
        "value": "Preis / Einheit"
      },
      "extras": {
        "default": "Extras",
        "value": "Extras"
      },
      "priceShiftName": {
        "default": "Charge / Discount",
        "value": "Belastung / Rabatt"
      },
      "percent": {
        "default": "Percent",
        "value": "Prozent"
      },
      "fix": {
        "default": "Fix",
        "value": "Fix"
      },
      "bookingTotalPrice": {
        "default": "Grand total",
        "value": "Gesamtbetrag"
      },
      "billingAmount": {
        "default": "Invoice amount",
        "value": "Rechnungsbetrag"
      },
      "receivedPayments": {
        "default": "Received payments",
        "value": "Erhaltene Zahlungen"
      }
    },
    "userBookings": {
      "archivedBookings": {
        "default": "Archived bookings",
        "value": "Vergangene Buchungen"
      },
      "activeBookings": {
        "default": "Active bookings",
        "value": "Aktive Buchungen"
      },
      "myBookings": {
        "default": "My bookings",
        "value": "Meine Buchungen"
      },
      "noBookingsYet": {
        "default": "No bookings yet.",
        "value": "Noch keine Buchungen"
      },
      "number": {
        "default": "Number",
        "value": "Nummer"
      },
      "object": {
        "default": "Rental object",
        "value": "Objekt"
      },
      "start": {
        "default": "Start",
        "value": "Start"
      },
      "end": {
        "default": "End",
        "value": "Ende"
      },
      "price": {
        "default": "Price",
        "value": "Preis"
      },
      "state": {
        "default": "Status",
        "value": "Status"
      },
      "loadMore": {
        "default": "Load more",
        "value": "Mehr laden"
      }
    },
    "search": {
      "location": {
        "default": "Location",
        "value": "Standort"
      },
      "allLocations": {
        "default": "All locations",
        "value": "Alle"
      },
      "chooseAllLocations": {
        "default": "All locations",
        "value": "Alle"
      },
      "noItemsLoadedYet": {
        "default": "No items loaded yet.",
        "value": "Noch keine Einträge geladen"
      },
      "objectType": {
        "default": "Object type",
        "value": "Kategorie"
      },
      "allCategories": {
        "default": "All categories",
        "value": "Alle"
      },
      "chooseAllCategories": {
        "default": "All categories",
        "value": "Alle"
      },
      "startDate": {
        "default": "Start date",
        "value": "Startdatum"
      },
      "noStartDateSelected": {
        "default": "No start date selected",
        "value": "Kein Startdatum gewählt"
      },
      "diration": {
        "default": "Duration",
        "value": "Dauer"
      },
      "to": {
        "default": "to",
        "value": "bis"
      },
      "count": {
        "default": "Qty.",
        "value": "Anzahl"
      },
      "enterUnitsCount": {
        "default": "Enter units count",
        "value": "Anzahl eingeben"
      },
      "timeUnit": {
        "default": "Time unit",
        "value": "Zeiteinheit"
      },
      "enterUnitsType": {
        "default": "Enter units type",
        "value": "Einheit angeben"
      },
      "properties": {
        "default": "Features",
        "value": "Eigenschaften"
      },
      "doNotCare": {
        "default": "Don't care",
        "value": "Keine gewählt"
      },
      "thereAreNoResults": {
        "default": "There were no results for your search.",
        "value": "Ihre Suche ergab keine Treffer"
      },
      "fromPrice": {
        "default": "Starting at",
        "value": "Ab"
      },
      "loadMore": {
        "default": "Load more",
        "value": "Mehr laden"
      },
      "resetParameters": {
        "default": "Reset All",
        "value": "Alles zurücksetzen"
      },
      "showAll": {
        "default": "Show All",
        "value": "Alle anzeigen"
      }         
    },
    "userProfile": {
      "street": {
        "default": "Street, Nr. *",
        "value": "Strasse, Nr. *"
      },      
      "addressAddition": {
        "default": "Address suffix",
        "value": "Adresszusatz"
      },
      "postNumber": {
        "default": "ZIP *",
        "value": "PLZ *"
      },
      "place": {
        "default": "Place *",
        "value": "Ort *"
      },
      "country": {
        "default": "Country *",
        "value": "Land *"
      },
      "registrationTitle": {
        "default": "Sign up",
        "value": "Registrieren"
      },
      "profileTitle": {
        "default": "Hallo",
        "value": "Hallo ${firstName}"
      },       
      "registrationSubtitle": {
        "default": "Sign up for wy.by.",
        "value": "Auf wy.by registrieren"
      },
      "profileSubtitle": {
        "default": "Edit your user profile.",
        "value": "Benutzerdaten ändern"
      },
      "customerInformation": {
        "default": "Customer information",
        "value": "Kundeninformation"
      },      
      "salutation": {
        "default": "Salutation *",
        "value": "Anrede *"
      },
      "firstName": {
        "default": "First name *",
        "value": "Vorname *"
      },
      "lastName": {
        "default": "Family name *",
        "value": "Nachname *"
      },
      "organization": {
        "default": "Organization",
        "value": "Organisation"
      },        
      "email": {
        "default": "Email *",
        "value": "E-Mail *"
      },
      "phone": {
        "default": "Phone",
        "value": "Telefon"
      },
      "mobilePhone": {
        "default": "Cellphone *",
        "value": "Mobiltelefon *"
      },
      "timeZone": {
        "default": "Timezone",
        "value": "Zeitzone"
      },
      "language": {
        "default": "Corresponce language",
        "value": "Korrespondenzsprache"
      },
      "postalAddress": {
        "default": "Postal Address",
        "value": "Post Adresse"
      },
      "billingAddress": {
        "default": "Billing Address",
        "value": "Rechnungsadresse"
      },      
      "useDifferentBillingAddress": {
        "default": "Different billing address",
        "value": "Abweichende Rechnungsadresse"
      },
      "password": {
        "default": "Password",
        "value": "Passwort"
      },
      "userNameReadOnly": {
        "default": "Username",
        "value": "Benutzername"
      },
      "userNameEditable": {
        "default": "Username *",
        "value": "Benutzername"
      },
      "oldPassword": {
        "default": "Old password",
        "value": "Altes Passwort"
      },
      "newPassword1": {
        "default": "New password *",
        "value": "Neues Passwort *"
      },
      "newPassword2": {
        "default": "Confirm password *",
        "value": "Passwort bestätigen *"
      },
      "acceptAgb": {
        "default": "I accept the ",
        "value": "Ich akzeptiere die "
      },
      "agb": {
        "default": "General terms & conditions",
        "value": "AGB"
      },
      "back": {
        "default": "Cancel",
        "value": "Abbrechen"
      },
      "registrationSave": {
        "default": "Save",
        "value": "Speichern"
      },
      "profileSave": {
        "default": "Save",
        "value": "Speichern"
      },
      "registrationStep2Title": {
        "default": "Registration",
        "value": "Registration"
      },
      "registrationStep2Subtitle": {
        "default": "Thank you very much for your registration.",
        "value": "Vielen Dank für Ihre Registrierung."
      },
      "registrationStep2Text": {
        "default": "Please follow a link in your email to activate the account.",
        "value": "Bitte klicken Sie den Link in Ihrer E-Mail um Ihr Konto zu aktivieren."
      },
      "registrationStep2GoHome": {
        "default": "Go to homepage",
        "value": "Zur Startseite"
      },
      "registrationStep4Title": {
        "default": "Registration",
        "value": "Registration"
      },
      "registrationStep4Subtitle": {
        "default": "You have registered successfully.",
        "value": "Sie haben sich erfolgreich registriert."
      },
      "registrationStep4GoHome": {
        "default": "Go to homepage",
        "value": "Zur Startseite"
      }
    },
    "authentication": {
      "loggedOutDueToInactivity": {
        "default": "You were logged out because of inactivity.",
        "value": "Infolge Inaktivität wurden Sie abgemeldet.",
      }
    },
    "forgottenPassword": {
      "resetPassword": {
        "default": "Reset password",
        "value": "Passwort zurücksetzen",
      },
      "enterEmailAddress": {
        "default": "Please enter the e-mail addresses you used for registration.",
        "value": "Bitte geben Sie die E-Mail Adressen ein, die Sie für die Registrierung verwendet haben.",
      }, 
      "yourEmailAddress": {
        "default": "Your e-mail address",
        "value": "Ihre E-Mail Adresse",
      }, 
      "cancel": {
        "default": "Cancel",
        "value": "Abbrechen",
      },   
      "sendEmail": {
        "default": "Send e-mail",
        "value": "E-Mail senden",
      }, 
      "forgotPasswordEmail": {
        "default": "Forgotten password e-mail",
        "value": "Passwort-Vergessen E-Mail",
      }, 
      "weHaveSentEmail": {
        "default": "We have sent an email with a password recovery link to ${email}. Please open the email and click on the password recovery link.",
        "value": "Wir haben eine E-Mail mit einem Link zur Passwort-Wiederherstellung an ${email} gesandt. Bitte öffnen Sie die E-Mail und klicken Sie auf den Link zur Passwort-Wiederherstellung.",
      },  
      "Home": {
        "default": "Homepage",
        "value": "Startseite",
      },
      "enterNewPassword": {
        "default": "Enter your new password and confirm it.",
        "value": "Geben Sie Ihr neues Passwort ein und bestätigen Sie es.",
      },   
      "username": {
        "default": "Username",
        "value": "Benutzername",
      }, 
      "newPassword": {
        "default": "New password",
        "value": "Neues Passwort",
      },  
      "repeatNewPassword": {
        "default": "Repeat new password",
        "value": "Neues Passwort wiederholen",
      },  
      "passwordComplexityDesc": {
        "default": "The password must be minimum 7 characters with at least one lowercase character and one special character.",
        "value": "Das Passwort muss mindestens 7 Zeichen lang sein, davon mindestens ein Kleinbuchstabe und ein Sonderzeichen.",
      },
      "save": {
        "default": "Save",
        "value": "Speichern",
      }, 
      "resetSuccessTitle": {
        "default": "Password successfully reset",
        "value": "Passwort erfolgreich zurückgesetzt",
      },   
      "resetSuccessDesc": {
        "default": "Your password was successfully reset. Please go to the start page and log in.",
        "value": "Ihr Passwort wurde erfolgreich neu gesetzt. Bitte gehen Sie zur Startseite und melden sich an.",
      },                                                                           
    }    
  },
  "unbound": {}
}


// WEBPACK FOOTER //
// ./src/translate/resources/deCH.js